import React, { useEffect, useState } from "react";
import Tabs from "../common/Tabs";
import Tubing from "./tubing";
import WellInput from "./well-input";
import Fluid from "./fluid";
import Others from "../others";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import useSchematicFacade from "../../facade/calculation/calculation-output/schematic.facade";
import useCalculationFacade from "../../facade/calculation/calculation.facade";
import useCableFacade from "../../facade/calculation/calculation-output/cable.facade";
import useTubingFacade from "../../facade/calculation/calculation-input/tubing.facade";
import { useSurfaceEquipmentFacade } from "../../facade/calculation/calculation-output/surfaceEquipment.facade";

const InputSection: React.FC = () => {
    const [activeTab, setActiveTab] = useState<number>(0);
    const { projectDetails, schematicData } = useAppSelector(state => state?.calculations);
    const { wellCableList } = useAppSelector((state) => state?.cable);
    const { tab1Input } = useAppSelector((state) => state?.tubing);
    const { fetchAboveEquipments, fetchBelowEquipments } = useSchematicFacade();
    const { updateSettingDepthReference } = useCalculationFacade();
    const { getSelectedCable } = useCableFacade();
    const { updateHiddenSwitchBoard, updateHiddenSurfVSD, updateSurfaceControllerType } = useTubingFacade();
    const { getTransformerEquipments } = useSurfaceEquipmentFacade();

    useEffect(() => {
        if (projectDetails && Object.keys(projectDetails).length > 0) {
            fetchAboveEquipments();
            fetchBelowEquipments();
            updateSurfaceControllerType(projectDetails?.tab1Input?.hdnCntrlTyp || "0");
            updateHiddenSwitchBoard(projectDetails?.tab1Input?.hiddenSwtchBrd || "");
            updateHiddenSurfVSD(projectDetails?.tab1Input?.hiddenSurfVSD || "");
            getTransformerEquipments();
        }
    }, [projectDetails]);

    useEffect(() => {
        if ((schematicData && Object.keys(schematicData).length > 0) || (projectDetails && Object.keys(projectDetails).length > 0)) {
            updateSettingDepthReference(schematicData?.miscellaneous?.setDepthType ?? 0);
        }
    }, [schematicData && Object.keys(schematicData).length > 0, projectDetails && Object.keys(projectDetails).length > 0]);

    useEffect(() => {
        if (wellCableList?.length > 0) {
            const selectedCable = wellCableList?.find((x: any) => x?.id === tab1Input?.hdnCable_CableType);
            getSelectedCable(selectedCable?.label || selectedCable?.name || "");
        }
    }, [wellCableList]);

    const handleTabChange = (tab: number): void => {
        setActiveTab(tab);
    };

    const tabs = [
        {
            label: "Tubing",
            content: <Tubing />,
        },
        {
            label: "Well",
            content: <WellInput />,
        },
        {
            label: "Fluid",
            content: <Fluid />,
        },
        {
            label: "Others",
            content: (
                <div>
                    <Others />
                </div>
            ),
        },
    ];
    return (
        <div
            className="flex items-start flex-col justify-between flex-1 rounded-[8px] border-darkcolor-400 bg-darkcolor-700 border-[1px] text-neutral-25 w-full h-full"
        >
            <Tabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} />
        </div>
    );
};

export default InputSection;
